import * as React from 'react';

import { deleteRules } from '../../api/rule';
import { useRuleContext } from '../../context/RuleStore';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

// Animated rainbow background box for delete modal
const RainbowDeleteBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  background: 'linear-gradient(-45deg, #ff6b6b, #4ecdc4, #45b7d1, #96ceb4, #ffeaa7, #fab1a0, #fd79a8, #a29bfe)',
  backgroundSize: '400% 400%',
  animation: 'rainbowDelete 5s ease infinite',
  border: '2px solid #000',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
  borderRadius: '12px',
  p: 4,
  
  '@keyframes rainbowDelete': {
    '0%': {
      backgroundPosition: '0% 50%',
    },
    '50%': {
      backgroundPosition: '100% 50%',
    },
    '100%': {
      backgroundPosition: '0% 50%',
    }
  },
  
  // Style text for better contrast
  '& .MuiTypography-root': {
    color: 'white',
    fontWeight: 'bold',
    textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
  }
}));

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export const ConfirmDeleteRuleModal = (props) => {
  const { id, name, getRulesAsync, onRuleDeleted } = props;
  const { state: ruleState, action: ruleActions } = useRuleContext();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleDelete = async () => {
    await deleteRules([id]);
    ruleActions.getRulesAsyncAction();
    handleClose();
    
    // Show notification if callback provided
    if (onRuleDeleted) {
      onRuleDeleted();
    }
  };
  return (
    <>
      <IconButton aria-label="delete" onClick={handleOpen}>
        <DeleteIcon />
      </IconButton>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <RainbowDeleteBox>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Comfirm Delete
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Are you sure you want to delete the rule '{name}'?
          </Typography>
          <Button onClick={handleClose} style={{ border: '20px ridge red' }}>
            Cancel
          </Button>
          &nbsp;&nbsp;
          <Button onClick={handleDelete} style={{ border: '20px ridge green' }}>
            Delete {name}
          </Button>
        </RainbowDeleteBox>
      </Modal>
    </>
  );
};
